<script>
	import { theme } from "$lib/utilities/theme";

	import ScreenSize from "$lib/components/ScreenSize.svelte";
	import Banner from "$lib/sections/Banner.svelte";
	import Menus from "$lib/sections/Menus.svelte";
	import AreaWeather from "./AreaWeather.svelte";
	import Languages from "./Languages.svelte";
	import Weather from "./Weather.svelte";

	export let data;
	export let preview = false;
	export let lang;
	export let area;

	let screenWidth;
	let breakpoint;

	$: headerClass =
		data?.content?.["settings"]?.["Header"]?.classes?.value?.headerClass
			?.value ||
		// `sticky top-0 shadow-lg z-20 grayscale`;
		` shadow-lg bg-base-300`;
	$: showWeather =
		data?.content?.["settings"]?.["Header"]?.showWeather?.value === "false"
			? false
			: true;
</script>

<ScreenSize bind:width={screenWidth} bind:breakpoint showBreakpoint={false} />

<!-- not sure but this might need an inline-block class -->
<header
	data-theme={$theme}
	class={`sticky top-0 z-20 ${headerClass}`}
	id="main-app-header"
>
	<div class="max-w-[1440px] mx-auto flex justify-between p-2 md:p-4">
		<!-- banner -->
		<div class="flex" id="main-app-banner">
			<Banner {data} {preview} />
		</div>
		<!-- mobile icon -->
		<div
			class="md:hidden flex flex-row justify-end w-full space-x-2 px-2 sm:px-4"
		>
			<ul class="my-auto">
				<Languages {data} />

				{#if showWeather && ["xs", "sm"].includes(breakpoint)}
					<Weather />
				{/if}
			</ul>
			<div
				class="flex justify-end my-auto"
				id="main-app-mobile-menus-show"
			>
				<label
					for="mobile-menu-drawer"
					aria-label="open sidebar"
					class=""
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24px"
						height="24px"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
						><line x1="3" y1="12" x2="21" y2="12"></line><line
							x1="3"
							y1="6"
							x2="21"
							y2="6"
						></line><line x1="3" y1="18" x2="21" y2="18"
						></line></svg
					>
				</label>
			</div>
		</div>
		<!-- menus -->
		<nav class="hidden md:block my-auto w-full list-none">
			<ul
				class="ml-2 sm:ml-4 w-full flex justify-end py-4 space-x-2 md:space-x-4 list-none px-2 sm:px-4"
			>
				<li>
					<ul
						class="flex flex-wrap gap-2 md:gap-4"
						id="main-app-menus"
					>
						<Menus {data} {lang} {area} />
					</ul>
				</li>
				<Languages {data} />
				{#if showWeather && ["md", "lg", "xl", "2xl"].includes(breakpoint)}
					<!-- {#if area} -->
					<!-- <AreaWeather {area} /> -->
					<!-- {:else} -->
					<Weather />
					<!-- {/if} -->
				{/if}
			</ul>
		</nav>
	</div>
</header>
